import { PRIORITIES, VEHICLE_STATUSES } from "@/lib/constants";

export function PriorityBadge({ priority, className = "" }) {
  const p = PRIORITIES[priority] || PRIORITIES[4];
  return (
    <span
      data-testid={`priority-badge-${priority}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${className}`}
      style={{ backgroundColor: p.bg, color: p.text, border: `1px solid ${p.border}` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: p.hex }} />
      {p.label} · P{priority}
    </span>
  );
}

export function StatusBadge({ status, className = "" }) {
  const s = VEHICLE_STATUSES[status] || VEHICLE_STATUSES.buiten_dienst;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${className}`}
      style={{ backgroundColor: s.bg, color: s.text, border: `1px solid ${s.border}` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: s.hex }} />
      {s.label}
    </span>
  );
}
